import {Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'sb-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['footer.component.scss'],
})
export class FooterComponent implements OnInit {
    @Input() twitter;
    @Input() facebook;
    constructor() {}
    ngOnInit() {}
}
